'use client'

import { useSyncExternalStore } from 'react'

const TICK_INTERVAL_MS = 5000

let now = Date.now()
let timerId = null
const listeners = new Set()

function emit() {
  now = Date.now()
  listeners.forEach((listener) => listener())
}

function subscribe(listener) {
  listeners.add(listener)

  if (!timerId) {
    timerId = window.setInterval(emit, TICK_INTERVAL_MS)
  }

  return () => {
    listeners.delete(listener)
    if (listeners.size === 0 && timerId) {
      window.clearInterval(timerId)
      timerId = null
    }
  }
}

function getSnapshot() {
  return now
}

function getServerSnapshot() {
  return Date.now()
}

export default function useNowTicker() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
